var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBellAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 1.73642C10.5598 1.69018 10.2812 1.6665 10.0001 1.6665C8.67397 1.6665 7.4022 2.19329 6.46452 3.13097C5.52684 4.06865 5.00006 5.34042 5.00006 6.6665C5.00006 9.24166 4.35045 11.0048 3.62478 12.171C3.01267 13.1547 2.7066 13.6466 2.71783 13.7838C2.73025 13.9357 2.76244 13.9937 2.88487 14.0845C2.99544 14.1665 3.49388 14.1665 4.49077 14.1665H15.5093C16.5062 14.1665 17.0046 14.1665 17.1152 14.0845C17.2376 13.9937 17.2698 13.9357 17.2822 13.7838C17.2934 13.6466 16.9874 13.1547 16.3752 12.1708C15.9652 11.5118 15.5794 10.6622 15.3215 9.58317",
    stroke: "#02698C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79517 17.5C8.38278 18.0186 9.15465 18.3333 10 18.3333C10.8454 18.3333 11.6173 18.0186 12.2049 17.5",
    stroke: "#02698C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 4.1665,
    r: 2.5,
    fill: "#FF6666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellAlert);
export default __webpack_public_path__ + "static/media/IconBellAlert.513e9b0458acd7ff5dba26d2dace8660.svg";
export { ForwardRef as ReactComponent };